import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { DecisionComments, Meeting, BoardMeetingDecision, MeetingsListResponse } from '../models/meetings';
import { Attendee, AttendeesListResponse } from '../models/attendance';
import { ActionShareholder } from 'modules/main/actions/commonModels';
import { BoardMember } from '../models/members';

export const onGetMeetingsForActiveBoard = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<MeetingsListResponse>>('dashboard/meetings', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMeetingsList = async (boardId: number, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<MeetingsListResponse>>(`dashboard/boards/${boardId}/meetings`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMeetingById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Meeting>>(`dashboard/meetings/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateMeeting = async (payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<Meeting>>(`dashboard/meetings`, payload);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onUpdateMeeting = async (id: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<Meeting>>(`dashboard/meetings/${id}`, payload);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onCancelMeeting = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/cancel`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onStartMeetingVoting = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/start-voting`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onStartMeetingAttendance = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/open-attendance`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onGetMeetingAttendees = async (id: string, page: number) => {
	try {
		const response = await axios.get<JsonResponse<AttendeesListResponse>>(`dashboard/meetings/${id}/attendees`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMeetingAttendeeById = async (id: string, attendeeId: number) => {
	try {
		const response = await axios.get<JsonResponse<{ attendance: Attendee }>>(`dashboard/meetings/${id}/attendees/${attendeeId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSearchShareholder = async (id: string, keyword: string) => {
	try {
		const response = await axios.get<JsonResponse<ActionShareholder[]>>(`dashboard/meetings/${id}/attendees/search`, {
			params: { keyword },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddAttendee = async (meetingId: string, board_member_id: string) => {
	try {
		const response = await axios.post<JsonResponse<ActionShareholder[]>>(`dashboard/meetings/${meetingId}/attendees`, { board_member_id }, {});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMeetingDecisions = async (meetingId: string) => {
	try {
		const response = await axios.get<JsonResponse<{ decisions: BoardMeetingDecision[]; decisions_comments_footer: string | null }>>(
			`dashboard/meetings/${meetingId}/decisions/comments`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddMeetingVote = async (meetingId: string, payload: FormData) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/add-vote`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onEndMeetingVoting = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/end-voting`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCloseMeeting = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/complete`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddMeetingDecisionComments = async (meetingId: string, comments: DecisionComments[], decisions_comments_footer: string) => {
	try {
		const response = await axios.put(`dashboard/meetings/${meetingId}/decisions/comments-bulk`, { comments, decisions_comments_footer });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSearchBoardMember = async (search: string) => {
	try {
		const response = await axios.get<JsonResponse<BoardMember[]>>(`dashboard/meetings/board-members`, { params: { search } });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPublishBoardMeeting = async (meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/meetings/${meetingId}/publish`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
